import React from "react";
import "./Catalogues.css";
import "../../css/bootstrap.css";
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-accessible-accordion/dist/minimal-example.css';
import { getAllObjects } from "../../services/CommonServices";
import {  Grid } from "react-bootstrap";

class FinancialReports extends React.Component {
  componentDidMount() {
    window.scroll(0, 0)
    getAllObjects("cms")
      .then(res => {
        this.setState({ wall_url: res.data[0].wall_url, floor_url: res.data[0].floor_url, porcelain_url: res.data[0].porcelain_url });
      });
  }


  handleViewClick = (viewOption) => {
    let win;
    if (viewOption === "wall") {
      win = window.open(this.state.wall_url, '_blank');
      win.focus();
    } else if (viewOption === "floor") {
      win = window.open(this.state.floor_url, '_blank');
      win.focus();
    } else {
      win = window.open(this.state.porcelain_url, '_blank');
      win.focus();
    }
  }
  render() {
    return (
      <div className="FinancialReports">
          <div className="wishlist__title ">
            <h2 className="main-line-title">
              Catalogues </h2>
          </div>
        <div className="catalogues-bg">
          <Grid style={{margin: 'auto'}}>
            <div className="Financial-Reports__content">
              <div className="catalogue-container">
                <button onClick={() => this.handleViewClick("floor")} type="button" className="main-button collection__btn btn btn-default catalogue-btn">Floor Catalogue</button>
                <button onClick={() => this.handleViewClick("wall")} type="button" className="main-button collection__btn btn btn-default catalogue-btn">Wall Catalogue</button>
                <button onClick={() => this.handleViewClick("porcelain")} type="button" className="main-button collection__btn btn btn-default catalogue-btn">Porcelain Catalogue</button>
              </div>
            </div>
          </Grid>
        </div>
      </div>
    )
  }
}
export default FinancialReports;
